import { render } from "./AppsList.vue?vue&type=template&id=37fccfa4"
import script from "./AppsList.vue?vue&type=script&lang=js"
export * from "./AppsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__